import { Restriction } from '@mews-commander/data-access';
import { WithServiceId } from '@mews-commander/types';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { SpacedDash } from '@mews-commander/ui';
import { Stack, StackItem } from '@optimus-web/core';
import { composeServiceIdFromProps, getServiceTimeUnit } from '@mews-commander/legacy-entities/src/ducks/services';
import { useCommanderSelector } from '@mews-commander/utils';
import { getFirstConditionLabelVariants, getSecondConditionLabelVariants } from '../../selectors';
import { getTransformedExceptions } from '../../utils';
import { RestrictionCalendarRowConditions } from '../../types';
import RestrictionDetailCard from './card';

interface Props extends WithServiceId {
    restrictions: Array<Restriction>;
    rowCondition: RestrictionCalendarRowConditions;
}
const RestrictionsDetailList = ({ serviceId, rowCondition, restrictions }: Props) => {
    const timeUnit = useCommanderSelector((state) =>
        composeServiceIdFromProps(getServiceTimeUnit)(state, { serviceId })
    );

    const firstConditionLabel = useCommanderSelector((state) =>
        // @ts-expect-error
        getFirstConditionLabelVariants(state, {
            rateId: rowCondition.rateId,
            rateGroupId: rowCondition.rateGroupId,
        })
    );

    const secondConditionLabel = useCommanderSelector((state) =>
        // @ts-expect-error
        getSecondConditionLabelVariants(state, {
            serviceId,
            resourceCategoryId: rowCondition.resourceCategoryId,
        })
    );

    return (
        <Stack spacing="200" vertical>
            <StackItem>
                {firstConditionLabel ? (
                    <span>{firstConditionLabel.name}</span>
                ) : (
                    <LocalizedText textKey={TextKey.AllRates} />
                )}
                <span>{SpacedDash}</span>
                {secondConditionLabel ? (
                    <span>{secondConditionLabel.name}</span>
                ) : (
                    <LocalizedText textKey={TextKey.AllSpaces} />
                )}
            </StackItem>
            <Stack spacing="200" vertical>
                {restrictions.map(({ conditions, exceptions, id }) => (
                    <RestrictionDetailCard
                        key={`${id}-detail-card`}
                        conditions={conditions}
                        exceptions={getTransformedExceptions({ exceptions }, timeUnit)}
                        restrictionId={id}
                        serviceId={serviceId}
                        timeUnit={timeUnit}
                    />
                ))}
            </Stack>
        </Stack>
    );
};

export default RestrictionsDetailList;
